module.exports = __webpack_public_path__ + "img/c8-logo.80c6210a.jpg";